module.exports = __webpack_public_path__ + "static/media/ticket.118bbbe9.svg";